import { jsx as _jsx } from "react/jsx-runtime";
export function List({ children }) {
    return _jsx("ul", { className: "list-disc space-y-2 pb-2 pl-5", children: children });
}
